import {
  API_HOST_JAVA
} from './local.js'
import Qs from 'qs'
import axios from 'axios'
import Lockr from 'lockr'
// import VueAxios from 'vue-axios'
const axiosJava = axios.create({
  baseURL: API_HOST_JAVA
  // baseURL: 'http://192.168.124.5:7002/v2/'
})
axiosJava.defaults.timeout = 1000 * 15
axiosJava.defaults.headers.authKey = Lockr.get('authKey')
axiosJava.defaults.headers.sessionId = Lockr.get('sessionId')
axiosJava.defaults.headers['Content-Type'] = 'application/json'

let pending = [] // 声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let CancelToken = axios.CancelToken
let removePending = (config) => {
  for (let p in pending) {
    if (pending[p].u === config.url + '&' + config.method) { // 当当前请求在数组中存在时执行函数体
      if (config.method == 'post' || config.method == 'put') {
        pending[p].f('cancel') // 执行取消操作
        pending.splice(p, 1) // 把这条记录从数组中移除
      }
    }
  }
}
// 返回处理
axiosJava.interceptors.response.use(function (response) {
  removePending(response) // 在一个ajax发送前执行一下取消操作
  if (response.data.code === -1) {
    // 清空登录信息
    Lockr.rm('authKey')
    Lockr.rm('sessionId')
    Lockr.rm('userInfo')
    Lockr.rm('firstRoutePath')
    // 跳转到登录页
    // router.push({path: '/login'})
    return response
  } else if (response.data.code > 101 && response.data.code != 200) {
    // _g.toastMsg('error', response.data.error)
    if (response.data.code == 401) {
      // 跳转到登录页
      router.push({path: '/login'})
    }
    return response
  } else {
    return response
  }
}, function (error) {
  return Promise.reject(error)
})


// 获取智盈用户列表
export function getUser (params) {
  let url = 'cloudDisk/getUser'
  return axiosJava.get(url, {params})
}
// 获取文件夹列表
export function queryList (params) {
  let url = 'cloudDisk/queryList'
  return axiosJava.get(url, {params})
}
// 新建文件夹
export function saveFile (params) {
  let url = 'cloudDisk/saveFile'
  return axiosJava.post(url, params)
}
// 更新文件夹
export function updateFileInfo (params) {
  let url = 'cloudDisk/updateFileInfo'
  return axiosJava.put(url, params)
}
// 删除文件夹
export function delFile (params) {
  let url = 'cloudDisk/delFile'
  return axiosJava.delete(url, {params})
}
// 查看文件夹详情
export function getFileDetails (params) {
  let url = 'cloudDisk/getFileDetails'
  return axiosJava.get(url, {params})
}
// 七牛token
export function qiniuToken (params) {
  let url = 'zy/qiniu/getUploadToken'
  return axiosJava.get(url, {params})
}
// 记录上传文件操作
export function saveFileInfo (params) {
  let url = 'cloudDisk/saveFileInfo'
  return axiosJava.post(url, params)
}
// 删除文件
export function delFileInfo (params) {
  let url = 'cloudDisk/delFileInfo'
  return axiosJava.delete(url, {params})
}
// 查看文件操作详情
export function getFileInfo (params) {
  let url = 'cloudDisk/getFileInfo'
  return axiosJava.get(url, {params})
}
// 记录下载文件操作
export function recordDownLoad (params) {
  let url = 'cloudDisk/recordDownLoad'
  return axiosJava.get(url, {params})
}

// 文件夹内的文件列表
export function viewFile (params) {
  let url = 'cloudDisk/viewFile'
  return axiosJava.get(url, {params})
}

